import icon from 'vue-svgicon';

icon.register({
    'regular/video-game-magic-wand': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M6.656 6.044L10.724 7.3l2.961-2.45a.454.454 0 0 1 .76.344l-.119 4.338 3.691 2.039a.477.477 0 0 1-.108.859l-4.036 1.444-1.444 4.036a.476.476 0 0 1-.858.108l-2.04-3.691-4.338.119a.454.454 0 0 1-.344-.76L7.3 10.724 6.044 6.656a.5.5 0 0 1 .612-.612zM13.873 13.873l9.377 9.377M18 2.25h3M19.5.75v3M2.25 20.25h3M3.75 18.75v3M9 3V.75M.75 9.75H3" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
